let counter = 0

export const createRandomId = () => {
  counter++
  return `_breakout_${counter}`
}
